<template>
  <div class="container">
    <div class="swiper">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="#39a9ed">
        <van-swipe-item
          v-for="(item, index) in cmsData?.bannerList"
          :key="index"
        >
          <div class="myswiper">
            <van-image fit="cover" :src="item.img" @click="detail(item)" />
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  components: {},
  props: ["cmsData"],
  data() {
    return {
      bannerList: [],
    };
  },
  methods: {
    detail(item) {
      console.log(item);
      this.ip = sessionStorage.getItem('Ip') || localStorage.getItem('Ip');
      if (item.type == 1) {
        this.$router.push({
          path: '/productDetails?id=' + item.id,
        });
      } else {
        // window.location.href = item.detailsUrl;
        if (item.detailsUrl.indexOf('casarte') > -1) {
          const token = this.$cookies.get('hbscToken') || sessionStorage.getItem('hbscToken');
          window.location.href = `https://jf.casarte.com/m/#/index2?access_token=${token}&jfSource=hbjfsc`
        } else {
          window.location.href = item.detailsUrl;
        }
      }
    },
  },
  mounted() {
    const self = this;
    const userAgent = navigator.userAgent.toLocaleLowerCase();
    if (userAgent.indexOf("micromessenger") != -1) {
      wx.miniProgram.getEnv((res) => {
        if (res.miniprogram) {
          self.cmsData.bannerList.some((item, i) => {
            if (item.detailsUrl.indexOf("casarte") > -1) {
              self.cmsData.bannerList.splice(i, 1);
              return true;
            }
          });
        }
        // else {//在微信中
        //   console.log("在微信中")
        // }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.container {
  background: linear-gradient(to bottom, #004ea1, #f7f7f7);
}

.swiper {
  width: 95%;
  // height: 400px;
  margin: 0 auto;
}

.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  text-align: center;
}

/deep/.van-image__img {
  width: 100%;
  border-radius: 20px;
  // height: 400px;
}
</style>
